import { FigureShot } from './FigureShot'

interface Props { cs: boolean }

function CsBody() {
  return (
    <>
      <p>
        Nasazení ShowX na reálnou produkci má tři fáze: příprava LAN segmentu, test show systému den před,
        a samotný den D s eskalační procedurou.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">FOH checklist — příprava LAN</h3>
      <ol>
        <li>
          <strong>LAN segment izolovaný od publika.</strong> FOH Mac, všechny stanice a show devices
          (OSC konzole, QLab, MIDI zařízení) musejí být ve stejném L2 segmentu. Bez NATu nebo firewallu
          mezi nimi.
        </li>
        <li>
          <strong>mDNS průchodnost.</strong> Ověř, že Bonjour/mDNS pakety nejsou blokované. Test: z iPadu
          otevři <code>http://showx.local:5300</code> — musí odpovědět. Pokud ne, nastav manuální IP (viz
          níže).
        </li>
        <li>
          <strong>Statická IP pro FOH Mac</strong> (doporučeno). Nastav v System Settings → Network.
          Dynamická IP z DHCP funguje, ale mDNS záznam se může zpozdit po restartu.
        </li>
        <li>
          <strong>Firewall macOS.</strong> Shell naslouchá na portu 5300 (Yjs + events WebSocket) a 9441
          (control hub pro MCP). Firewall nesmí tyto porty blokovat pro lokální LAN. V System Settings →
          Privacy & Security → Firewall → Options přidej ShowX do povolených.
        </li>
        <li>
          <strong>Testovací pairing všech stanic.</strong> Na každém zařízení otevři browser, naskenuj QR
          nebo zadej IP:5300, spáruj. Po úspěšném pairingu zkontroluj, že stanice vidí demo show cuelist.
        </li>
        <li>
          <strong>Verifikace dispatch logu.</strong> Spusť testovací GO na cue s OSC payloadem. V shellu v
          záložce Dispatch Log zkontroluj, že se záznam objeví a OK status (ne error). Pokud error, zkontroluj
          routing table (device host/port) a zda je target device online.
        </li>
        <li>
          <strong>Timecode zdroj.</strong> Nastav v záložce Devices → Clock:
          <ul>
            <li><code>internal</code> — ShowX vlastní hodiny. Výchozí. Pro ruční GO workflow.</li>
            <li><code>MTC</code> — MIDI Time Code z externího zdroje (QLab, DAW). Vyžaduje MIDI vstupní port.</li>
            <li><code>LTC</code> — SMPTE Linear Time Code z audio vstupu. Vyžaduje audify audio vstup.</li>
          </ul>
          LTC a MTC jsou podporovány od v0.8.0. Při LTC: zkontroluj, že lock indikátor v Devices záložce
          ukazuje zeleně (2 konsekutivní framy přijaty).
        </li>
      </ol>

      <FigureShot
        src="/shots/prirucka/04_shell_devices.png"
        alt="ShowX shell — záložka Devices s timecode nastavením a seznamem zařízení"
        caption="Shell · Devices záložka · timecode zdroj + připojené zařízení"
      />

      <h3 className="display-serif text-xl mt-10 mb-3">Den -1: systémový test</h3>
      <ol>
        <li>Otevři produkční <code>.showx</code> soubor, zkontroluj metadata (název, místo, datum).</li>
        <li>Projdi celý cuelist v REHEARSAL módu — zkontroluj payloady, routing, standby notes.</li>
        <li>
          Proveď test GO na každé kategorii payloadů: OSC, LX ref, MIDI, webhook. Zkontroluj odpovědi
          v Dispatch Logu.
        </li>
        <li>Otestuj pairing se všemi stanicemi — role, dept assignments, SM pohled.</li>
        <li>Ulož show (Cmd+S), ověř, že <code>.showx</code> soubor je zálohovatelný.</li>
        <li>Proveď zálohu <code>.showx</code> na USB nebo cloud (mimo FOH Mac).</li>
      </ol>

      <h3 className="display-serif text-xl mt-10 mb-3">Den D: timeline</h3>
      <ol>
        <li><strong>T-60 min:</strong> Zapni FOH Mac, spusť ShowX, otevři show soubor.</li>
        <li><strong>T-45 min:</strong> Pairing stanic — zkontroluj role a dept. Dispatch log test.</li>
        <li><strong>T-30 min:</strong> Přepni do SHOW módu (potvrzení + snapshot).</li>
        <li><strong>T-15 min:</strong> Finální kontrola — mode badge na všech stanicích zobrazuje SHOW.</li>
        <li><strong>T-0:</strong> Show start. GO ze SM stanice.</li>
        <li><strong>Po show:</strong> Přepni zpět do REHEARSAL. Záloha <code>.showx</code>.</li>
      </ol>

      <h3 className="display-serif text-xl mt-10 mb-3">Eskalace</h3>
      <ul>
        <li>
          <strong>FOH Mac selže za živé show</strong> — pokud existuje zálohovací Mac, zkopíruj <code>.showx</code>{' '}
          soubor a spusť ShowX. Stanice se připojí znovu po mDNS nebo manuálním IP. Ztracené are CRDT merges
          z IndexedDB.
        </li>
        <li>
          <strong>SM iPad se odpojí</strong> — závisí na <code>sm_offline_policy</code>: freeze (nic nestřílí),
          delegate (autorita přejde na jiného operátora), auto_continue (cues pokračují samy).
        </li>
        <li>
          <strong>OSC device přestane odpovídat</strong> — Dispatch Log zobrazí error. Show pokračuje; only
          ten jeden payload selže. Po nápravě příčiny (restartuj target device) se příští GO vrátí k normálu.
        </li>
      </ul>
      <p className="mt-8 text-sm text-muted">
        Viz také:{' '}
        <a href="/guide" className="text-accent-deep underline underline-offset-2">Průvodce instalací</a>{' '}
        — stažení DMG, první spuštění, systémové požadavky.
      </p>
    </>
  )
}

function EnBody() {
  return (
    <>
      <p>
        Deploying ShowX to a real production has three phases: preparing the LAN segment, testing the show
        system the day before, and the day-of procedure with an escalation path.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">FOH checklist — LAN setup</h3>
      <ol>
        <li>
          <strong>LAN segment isolated from the audience.</strong> FOH Mac, all stations, and show devices
          (OSC console, QLab, MIDI devices) must be on the same L2 segment. No NAT or firewall between them.
        </li>
        <li>
          <strong>mDNS reachability.</strong> Verify Bonjour/mDNS packets are not blocked. Test: from iPad
          open <code>http://showx.local:5300</code> — it must respond. If not, set a manual IP (see below).
        </li>
        <li>
          <strong>Static IP for FOH Mac</strong> (recommended). Set in System Settings → Network.
          Dynamic DHCP works but the mDNS record may lag after a restart.
        </li>
        <li>
          <strong>macOS Firewall.</strong> Shell listens on port 5300 (Yjs + events WebSocket) and 9441
          (control hub for MCP). The firewall must not block these ports for local LAN. In System Settings →
          Privacy & Security → Firewall → Options, add ShowX to allowed apps.
        </li>
        <li>
          <strong>Pairing test for all stations.</strong> On each device, open a browser, scan the QR or
          type IP:5300, pair. After successful pairing, verify the station can see the demo show cuelist.
        </li>
        <li>
          <strong>Dispatch log verification.</strong> Fire a test GO on a cue with an OSC payload. In the
          shell Dispatch Log tab, verify the entry appears with OK status (not error). If error, check the
          routing table (device host/port) and whether the target device is online.
        </li>
        <li>
          <strong>Timecode source.</strong> Configure in Devices tab → Clock:
          <ul>
            <li><code>internal</code> — ShowX own clock. Default. For manual GO workflows.</li>
            <li><code>MTC</code> — MIDI Time Code from an external source (QLab, DAW). Requires MIDI input port.</li>
            <li><code>LTC</code> — SMPTE Linear Time Code from audio input. Requires audify audio input.</li>
          </ul>
          LTC and MTC are supported from v0.8.0. For LTC: verify that the lock indicator in the Devices tab
          shows green (2 consecutive frames received).
        </li>
      </ol>

      <FigureShot
        src="/shots/prirucka/04_shell_devices.png"
        alt="ShowX shell — Devices tab with timecode settings and device list"
        caption="Shell · Devices tab · timecode source + connected devices"
      />

      <h3 className="display-serif text-xl mt-10 mb-3">Day -1: system test</h3>
      <ol>
        <li>Open the production <code>.showx</code> file, check metadata (title, venue, date).</li>
        <li>Walk through the entire cuelist in REHEARSAL mode — check payloads, routing, standby notes.</li>
        <li>
          Run a test GO on each payload category: OSC, LX ref, MIDI, webhook. Check responses in Dispatch Log.
        </li>
        <li>Test pairing with all stations — roles, dept assignments, SM view.</li>
        <li>Save the show (Cmd+S), verify the <code>.showx</code> file is backed up.</li>
        <li>Back up the <code>.showx</code> file to USB or cloud (off the FOH Mac).</li>
      </ol>

      <h3 className="display-serif text-xl mt-10 mb-3">Day of: timeline</h3>
      <ol>
        <li><strong>T-60 min:</strong> Boot FOH Mac, launch ShowX, open the show file.</li>
        <li><strong>T-45 min:</strong> Pair stations — check roles and depts. Dispatch log test.</li>
        <li><strong>T-30 min:</strong> Switch to SHOW mode (confirm + snapshot).</li>
        <li><strong>T-15 min:</strong> Final check — mode badge on all stations shows SHOW.</li>
        <li><strong>T-0:</strong> Show start. GO from SM station.</li>
        <li><strong>Post-show:</strong> Switch back to REHEARSAL. Back up <code>.showx</code>.</li>
      </ol>

      <h3 className="display-serif text-xl mt-10 mb-3">Escalation</h3>
      <ul>
        <li>
          <strong>FOH Mac fails during the show</strong> — if a backup Mac is available, copy the{' '}
          <code>.showx</code> file and launch ShowX. Stations reconnect via mDNS or manual IP. CRDT merges
          from IndexedDB are preserved.
        </li>
        <li>
          <strong>SM iPad disconnects</strong> — depends on <code>sm_offline_policy</code>: freeze (nothing
          fires), delegate (authority moves to another operator), auto_continue (cues proceed on trigger).
        </li>
        <li>
          <strong>OSC device stops responding</strong> — Dispatch Log shows error. Show continues; only that
          one payload fails. After fixing the root cause (restart the target device), the next GO returns to
          normal.
        </li>
      </ul>
      <p className="mt-8 text-sm text-muted">
        See also:{' '}
        <a href="/guide" className="text-accent-deep underline underline-offset-2">Installation guide</a>{' '}
        — DMG download, first launch, system requirements.
      </p>
    </>
  )
}

export default function Chapter9({ cs }: Props) {
  return (
    <article id="kap-9" className="scroll-mt-24">
      <h2 className="display-serif text-display-2 leading-tight mb-8">
        {cs ? '9. Nasazení do reálu' : '9. Production deployment'}
      </h2>
      <div className="copy prose-guide max-w-none">
        {cs ? <CsBody /> : <EnBody />}
      </div>
    </article>
  )
}
